import {
  viandas2Get,
  viandas2Post,
  viandas2Put,
  viandas2Patch,
} from "../../../common/service/viandas2Client";

export const getMenus = (idProveedor) =>
  viandas2Get("/rrhh/menus", idProveedor ? { id_proveedor: idProveedor } : undefined);

export const crearMenu = (idProveedor, nombre) =>
  viandas2Post("/rrhh/menus", { id_proveedor: idProveedor, nombre });

export const actualizarMenu = (id, nombre, idProveedor) =>
  viandas2Put(`/rrhh/menus/${id}`, { nombre, id_proveedor: idProveedor });

export const cambiarEstadoMenu = (id, activo) =>
  viandas2Patch(`/rrhh/menus/${id}/estado`, { activo });
